export const newsSelector = (state) => state.news;
export const pupSelector = (state) => state.pup;
export const accountSelector = (state) => state.account;
export const storeProductSelector = (state) => state.storePro;
export const dealSelector = (state) => state.deal;
export const configMenuSelector = (state) => state.menu;
export const bannerSelector = (state) => state.banner;
export const statisticsSelector = (state) => state.statistics;
export const surveySelector = (state) => state.survey;
export const spamSelector = (state) => state.spam;
export const groupNotificationSelector = (state) => state.groupNotification;
export const templatesMessageSelector = (state) => state.templatesMessage;
